import React, { useState, useMemo } from "react";
import { FileText } from "lucide-react";
import { LOG_COLORS, formatLogArg } from "./executionUtils";

export default function LogsSection({ logs }) {
    const [showRaw, setShowRaw] = useState(false);
    const entries = useMemo(() => {
        if (!logs) return null;
        if (Array.isArray(logs)) return logs;
        if (typeof logs === "string") return [{ type: "log", args: [logs] }];
        if (typeof logs === "object") return Object.entries(logs).map(([k, v]) => ({ type: "log", args: [`${k}: ${formatLogArg(v)}`] }));
        return null;
    }, [logs]);

    if (!entries || entries.length === 0) return null;

    return (
        <div>
            <div className="flex items-center justify-between mb-1">
                <div className="flex items-center gap-1 text-[10px] font-medium text-gray-500">
                    <FileText size={10} /> Logs ({entries.length} entr{entries.length !== 1 ? "ies" : "y"})
                </div>
                <button onClick={() => setShowRaw((v) => !v)} className="text-[10px] text-gray-400 hover:text-gray-600">
                    {showRaw ? "Table" : "Raw"}
                </button>
            </div>
            {showRaw ? (
                <pre className="text-[11px] font-mono text-gray-600 bg-gray-50 rounded border border-gray-200 p-2 whitespace-pre-wrap break-words max-h-[200px] overflow-y-auto">
                    {JSON.stringify(logs, null, 2)}
                </pre>
            ) : (
                <div className="border border-gray-200 rounded overflow-hidden max-h-[200px] overflow-y-auto">
                    <table className="w-full text-[11px]">
                        <thead className="bg-gray-50 sticky top-0 z-10">
                            <tr className="border-b border-gray-200">
                                <th className="text-left px-2 py-1 font-medium text-gray-500 w-[50px]">Type</th>
                                <th className="text-left px-2 py-1 font-medium text-gray-500">Message</th>
                            </tr>
                        </thead>
                        <tbody>
                            {entries.filter(Boolean).map((entry, idx) => (
                                <tr key={idx} className={`border-b border-gray-100 ${idx % 2 ? "bg-gray-50" : "bg-white"}`}>
                                    <td className={`px-2 py-1 font-mono ${LOG_COLORS[entry.type] || LOG_COLORS.log}`}>
                                        {entry.type || "log"}
                                    </td>
                                    <td className="px-2 py-1 text-gray-700 whitespace-pre-wrap break-words">
                                        {Array.isArray(entry.args) ? entry.args.map(formatLogArg).join(" ") : formatLogArg(entry)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
